@if (loaded()) {
  @if (smallestPackage() || largerPackages().length > 0) {
    <ct-lib-radio-card-group
      orientation="vertical"
      [value]="selectedOption()"
      (valueChange)="selectedOption.set($event)"
      [disabled]="disabled()"
    >
      @if (smallestPackage(); as smallest) {
        <ct-lib-radio-card
          [value]="CUSTOM_CREDITS_OPTION"
          [label]="
            'company-tool.snippets.credits-booking-modal.custom-option-title'
              | transloco
          "
          [price]="
            customTotalPrice()
              | currency: smallest.currency.toUpperCase() : 'symbol' : '1.0-0'
          "
          [sublabel]="
            'company-tool.snippets.credits-booking-modal.custom-option-sublabel'
              | transloco
                : {
                    price:
                      displayAmount(smallest)
                      | currency
                        : smallest.currency.toUpperCase()
                        : 'symbol'
                        : '1.0-0',
                  }
          "
          [disabled]="disabled()"
        >
          <app-number-stepper
            radioCardAction
            [(value)]="customPackageCount"
            [min]="1"
            (valueChange)="selectedOption.set(CUSTOM_CREDITS_OPTION)"
          />
          @if (
            selectedOption() === CUSTOM_CREDITS_OPTION && showPackageHint()
          ) {
            <ct-lib-info-banner
              radioCardFooter
              type="info"
              class="package-hint mb-0"
              @collapse
            >
              <p>
                {{
                  'company-tool.snippets.credits-booking-modal.package-hint'
                    | transloco
                }}
              </p>
            </ct-lib-info-banner>
          }
        </ct-lib-radio-card>
      }

      @if (largerPackages().length > 0) {
        <div class="separator-line">
          <span>{{
            'company-tool.snippets.credits-booking-modal.or-select-package'
              | transloco
          }}</span>
        </div>

        @for (pack of largerPackages(); track pack.id) {
          <ct-lib-radio-card
            [value]="pack.id"
            [label]="productTitle(pack)"
            [price]="
              displayAmount(pack)
                | currency: pack.currency.toUpperCase() : 'symbol' : '1.0-0'
            "
            [disabled]="disabled()"
          ></ct-lib-radio-card>
        }
      }
    </ct-lib-radio-card-group>
  }
} @else {
  <div class="loading-wrapper">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        height: '88px',
        width: '100%',
        'border-radius': '15px',
      }"
      count="4"
      [animation]="
        themingService.theme === 'dark' ? 'progress-dark' : 'progress'
      "
    ></ngx-skeleton-loader>
  </div>
}
